var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorrespondents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 207,
    viewBox: "0 0 174 207",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M174 86.8064C174 134.748 103.731 207 87 207C70.2692 207 0 134.748 0 86.8064C0 38.8646 38.9512 0 87 0C135.049 0 174 38.8646 174 86.8064Z",
    fill: "#6987FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.6168 51.7499C56.9926 51.7499 50.6525 58.1637 50.6525 66.2755C50.6525 74.3874 56.9926 80.8011 64.6168 80.8011C72.2409 80.8011 78.581 74.3874 78.581 66.2755C78.581 58.1637 72.2409 51.7499 64.6168 51.7499ZM44.9025 66.2755C44.9025 55.1672 53.6407 45.9999 64.6168 45.9999C75.5928 45.9999 84.331 55.1672 84.331 66.2755C84.331 77.3839 75.5928 86.5511 64.6168 86.5511C53.6407 86.5511 44.9025 77.3839 44.9025 66.2755Z",
    fill: "#03152D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.4425 91.0415C48.9269 91.0415 37.1812 102.754 37.1812 117.176V129.345L91.9613 114.982C90.8416 101.585 79.5631 91.0415 65.7912 91.0415H63.4425ZM92.0526 120.902V133.071C92.0526 134.659 93.3398 135.946 94.9276 135.946C96.5154 135.946 97.8026 134.659 97.8026 133.071V117.176C97.8026 99.5548 83.4589 85.2915 65.7912 85.2915H63.4425C45.7749 85.2915 31.4312 99.5548 31.4312 117.176V133.071C31.4312 133.962 31.8444 134.803 32.5498 135.347C33.2553 135.892 34.1734 136.078 35.0353 135.852L92.0526 120.902Z",
    fill: "#03152D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.205 34.9106C103.183 34.9106 96.6798 41.414 96.6798 49.4362C96.6798 57.4585 103.183 63.9618 111.205 63.9618C119.228 63.9618 125.731 57.4585 125.731 49.4362C125.731 41.414 119.228 34.9106 111.205 34.9106ZM90.9298 49.4362C90.9298 38.2383 100.008 29.1606 111.205 29.1606C122.403 29.1606 131.481 38.2383 131.481 49.4362C131.481 60.6341 122.403 69.7118 111.205 69.7118C100.008 69.7118 90.9298 60.6341 90.9298 49.4362Z",
    fill: "#03152D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.464 74.2022C98.6708 74.2022 88.7013 81.8733 85.3156 92.4004C84.8294 93.912 83.21 94.7432 81.6984 94.2571C80.1868 93.7709 79.3556 92.1515 79.8417 90.6399C83.977 77.7824 96.1244 68.4522 110.464 68.4522H112.822C130.544 68.4522 144.952 82.7045 144.952 100.337V116.232C144.952 117.82 143.665 119.107 142.077 119.107C140.49 119.107 139.202 117.82 139.202 116.232V100.337C139.202 85.9258 127.415 74.2022 112.822 74.2022H110.464Z",
    fill: "#03152D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.2015 108.513L34.03 124.1L32.5417 118.546L90.7133 102.959L92.2015 108.513Z",
    fill: "#03152D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrespondents);
export default __webpack_public_path__ + "static/media/correspondents.acbefd91adde1e60ced2a6fc08d51687.svg";
export { ForwardRef as ReactComponent };